// extracted by mini-css-extract-plugin
export default {"changelog":"Changelog_changelog__p0bdP","topHeader":"Changelog_topHeader__NoCyK","lastUpdated":"Changelog_lastUpdated__SIDqo"};